import { css } from '@repo/pandacss/styled-system/css';
import { LinkType } from '@repo/segment/enums';
import { type AnalyticsType } from '@repo/segment/types';
import { EntityPlacementCtaTypeEnum, MonetizableEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType, ImageType } from '@repo/supergraph/marketplace/types';
import Image from 'next/image';
import { CtaLink } from '../../../../CtaLink';
import { IMAGE_HEIGHT_DESKTOP, IMAGE_WIDTH_DESKTOP } from '../constants';

type Props = {
  ctaAnalytics: AnalyticsType;
  image?: ImageType;
  cta?: CtaType;
  displayName?: string;
  monetizable?: MonetizableEnum;
};

export const CtaImage = ({ ctaAnalytics, cta, displayName, image }: Props) => {
  return (
    <div className={css({ width: 'full' })}>
      {cta ? (
        <CtaLink
          cta={{ ...cta, type: EntityPlacementCtaTypeEnum.ProductImage }}
          analyticsPayload={ctaAnalytics}
          linkType={LinkType.PRODUCT_IMAGE}
          monetizable={ctaAnalytics.monetizable}
        >
          <div
            className={css({
              display: 'flex',
              '& img': {
                maxWidth: {
                  base: 'var(--cta-image-width-mobile)',
                  md: 'var(--cta-image-width-desktop)',
                },
              },
            })}
          >
            {image && image.source && displayName && (
              <Image
                src={image.source}
                alt={image.alt ?? displayName}
                width={IMAGE_WIDTH_DESKTOP}
                height={IMAGE_HEIGHT_DESKTOP}
                style={{ objectFit: 'contain' }}
              />
            )}
          </div>
        </CtaLink>
      ) : (
        <>
          {image && image.source && displayName && (
            <Image
              src={image.source}
              alt={image.alt ?? displayName}
              width={IMAGE_WIDTH_DESKTOP}
              height={IMAGE_HEIGHT_DESKTOP}
              style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
          )}
        </>
      )}
    </div>
  );
};
